import { ClassData } from '@models/class-data';
import { EventEmailSection } from '@models/events/event-email-section.model';
import { EventEmailType } from '@models/events/event-email-type.enum';

export class EventEmail {
  id: number;
  backgroundColor?: string;
  bodyColor?: string;
  backgroundUrl?: string;
  type: EventEmailType;
  eventId: number;
  spaceId?: number;
  sections: EventEmailSection[];
  subject?: string;
  preheader?: string | null;
  eventAttendeeTypeId?: number;
  variableMappings?: Record<string, number>;

  constructor(json: ClassData<EventEmail>) {
    this.id = +json.id;
    this.backgroundColor = json.backgroundColor;
    this.bodyColor = json.bodyColor;
    this.backgroundUrl = json.backgroundUrl;
    this.type = json.type;
    this.eventId = json.eventId;
    this.spaceId = json.spaceId ? +json.spaceId : undefined;
    this.sections = json.sections || [];
    this.subject = json.subject;
    this.preheader = json.preheader;
    this.eventAttendeeTypeId = json.eventAttendeeTypeId
      ? +json.eventAttendeeTypeId
      : undefined;
    this.variableMappings = json.variableMappings;
  }
}
